import { extend } from 'vee-validate'
import {
  max as rule_max,
  alpha_spaces as rule_alpha_spaces,
  image as rule_image,

} from 'vee-validate/dist/rules'

export const max = extend('max', rule_max)

export const image = extend('image', rule_image)

export const alphaSpaces = extend('alpha-spaces', rule_alpha_spaces)

export function maxCharacters(e, maxChar) {
  if (e.target.value.length >= maxChar) {
    e.preventDefault()
  }
}
